export class Oui {

	public grpCoordonnateur: string;

	constructor() {
		this.grpCoordonnateur = '';

	}
}
